import React from 'react';
import { useForm } from 'react-final-form';

import { required } from 'common/forms/FormValidationHelper';
import { useSelector } from 'hooks/useSelector';
import { getLoginUsername, getSignInLoading } from 'modules/auth/selectors';
import { Input } from 'ui/base';
import FormField from 'ui/form/FormField';

const Username = () => {
  const { submit } = useForm();
  const isSigningIn = useSelector(getSignInLoading);
  const initialUsername = useSelector(getLoginUsername);

  return (
    <FormField name="userName" labelId="username" required validate={required} initialValue={initialUsername}>
      {input => <Input {...input} data-cy="username" onPressEnter={submit} disabled={isSigningIn} />}
    </FormField>
  );
};

export default Username;
